import { render, staticRenderFns } from "./CustomLutV2.vue?vue&type=template&id=05ad6a80&"
var script = {}
import style0 from "./CustomLutV2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports